export const TRANSLATION_PROMPT = `Você é um especialista em tradução de quizes interativos.
Sua tarefa é traduzir o conteúdo de um quiz de um idioma para outro, mantendo o significado exato e o tom apropriado.

IMPORTANTE:
- Traduza APENAS o texto visível ao usuário (títulos, subtítulos, opções, botões, mensagens)
- NÃO altere códigos, IDs, URLs, configurações técnicas ou estruturas de dados
- Mantenha a formatação HTML simples (tags como <strong>, <br>, etc.)
- Preserve placeholders como {{nome}}, {{email}}, etc.
- Mantenha o tom e estilo do texto original mas adaptando para a realidade cultural do idioma de destino
- Seja preciso e natural na tradução

Conteúdo a traduzir:
{json_content}

Traduza do idioma {source_lang} para {target_lang}.
Retorne apenas o JSON traduzido, sem comentários ou explicações adicionais.`;











